import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from '../../services/store.service';

@Component({
    selector: 'app-module-language-mobile',
    templateUrl: './language-mobile.component.html',
    styleUrls: ['./language-mobile.component.scss'],
    standalone: false
})
export class LanguageMobileModuleComponent implements OnInit {
  private langBrowser: string;

  constructor(private translateService: TranslateService, public storeService: StoreService) {
    this.langBrowser = this.translateService.getBrowserLang() ?? 'it';
  }
  ngOnInit(): void {
    this.storeService.getLanguagesCollection();
    const efilLangToUse = localStorage.getItem('efil-lang-to-use');
    if(efilLangToUse && efilLangToUse != null && efilLangToUse != '') {
      this.setLanguage(efilLangToUse);
    } else {
      this.setLanguage(this.langBrowser);
    }
  }
  setLanguage(lang: string) {
    const langToUse = lang.toLowerCase();
    this.translateService.use(langToUse);
    this.storeService.languagesCollection.forEach(l => {
      l.default = l.code.toLowerCase() == langToUse;
    });
    localStorage.setItem('efil-lang-to-use',langToUse);
    this.storeService.fixAuthoritiesCollection(langToUse);
    this.storeService.fixAuthorityInfo(langToUse);
  }

}
